import { PAGOS_PROYECTOS } from '../actions/types';

const marker = String.fromCharCode(92,117,48,51,48,48,45,92,117,48,51,54,102);
const normalizeRegex = new RegExp('[' + marker + ']', 'g');

const normalize = (val) => {
    if (val === null || val === undefined) return '';
    return (val + '')
        .toLowerCase()
        .normalize('NFD')
        .replace(normalizeRegex, '')
        .trim();
};

const initialState = {
    listado: [],
    filtrado: [],
    error: null
};

export default function pagosProyectosReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case PAGOS_PROYECTOS.LISTAR: {
            const listado = Array.isArray(payload) ? payload : [];
            return {
                ...state,
                listado,
                filtrado: listado,
                error: null
            };
        }

        case PAGOS_PROYECTOS.FILTRAR: {
            const texto = normalize(payload);
            if (!texto) {
                return { ...state, filtrado: state.listado };
            }

            const filtrado = state.listado.filter((p) => {
                const metodo = normalize(p?.metodo_pago?.nombre);
                const referencia = normalize(p?.referencia);
                const observaciones = normalize(p?.observaciones);
                const responsable = normalize(`${p?.responsable?.nombre || ''} ${p?.responsable?.apellido || ''}`);

                return metodo.includes(texto) || referencia.includes(texto) || observaciones.includes(texto) || responsable.includes(texto);
            });

            return { ...state, filtrado };
        }

        case PAGOS_PROYECTOS.LIMPIAR:
            return { ...initialState };

        case PAGOS_PROYECTOS.ERROR:
            return { ...state, error: payload };

        default:
            return state;
    }
}
